<template>
  <v-btn
    color="#4989d1"
    style="color: white;"
    :dark="!disabled"
    :disabled="disabled"
    @click.stop="save"
    class="ml-3">
    途中保存
  </v-btn>
</template>

<script>

export default {
  props: {
    saveFnc:{
      type: Function
    },
    disabled:{
      type: Boolean,
      default: false
    },
  },

  methods: {
    async save() {
      this.$app.$refs.loading.open({type: 'normal', message: '処理中です。少々お待ちください。'})
      await this.saveFnc()
      this.$app.$refs.loading.close()
      this.$toasted.global.success({ message: '途中保存が完了しました' })
    },
  },
}
</script>
